module.exports = __webpack_public_path__ + "static/investing-23e266f54d3fc46e203588ea15f9dcc8.svg";